export class SubmitMyMPARequestRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "action",
            "baseName": "action",
            "type": "MPASubmitAction",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubmitMyMPARequestRequest.attributeTypeMap;
    }
    constructor() {
    }
}
